import LazyLoad from 'vanilla-lazyload';

const lazyContent = new LazyLoad();
